import {defaultTheme} from '@ibibo/build-theme';

export default function getRatingsColor(ratingCount: number, isTA = false): string {
  if (isTA) return defaultTheme.colors.green.taGreen;

  if (ratingCount >= 4.5) {
    return defaultTheme.colors.green.darkGreen;
  }

  if (ratingCount < 4.5 && ratingCount >= 4) {
    return defaultTheme.colors.green.bgDarkGreen;
  }

  if (ratingCount < 4 && ratingCount >= 3.5) {
    return defaultTheme.colors.green.ratingGreen;
  }

  if (ratingCount < 3.5 && ratingCount >= 3) {
    return defaultTheme.colors.yellow.ratingYellow;
  }

  if (ratingCount < 3 && ratingCount >= 2.5) {
    return defaultTheme.colors.orange.ratingOrange;
  }

  if (ratingCount < 2.5 && ratingCount >= 1) {
    return defaultTheme.colors.red.ratingRed;
  }

  return defaultTheme.colors.cyan.base;
}
